module.exports = __webpack_public_path__ + "media/images/logo-admin-e4492deab05d2c93ca2342585d5e59ef.png";